'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Music, User, Send, Loader2 } from 'lucide-react'

export default function SongRequestForm({ eventId }: { eventId: string }) {
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setLoading(true)
    const formData = new FormData(e.currentTarget)
    
    try {
      await fetch('/api/requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventId,
          songName: formData.get('songName'),
          artist: formData.get('artist')
        })
      })
      router.refresh()
      e.currentTarget.reset()
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={submit} className="compact-form space-y-2">
      <div className="space-y-2">
        <div className="relative">
          <Music className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
          <input 
            name="songName" 
            placeholder="Song name..." 
            required 
            autoComplete="off"
            className="input-neon request-input"
          />
        </div>
        
        <div className="relative">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
          <input 
            name="artist" 
            placeholder="Artist (optional)" 
            autoComplete="off"
            className="input-neon request-input"
          />
        </div>
      </div>

      <button type="submit" disabled={loading} className="btn-neon w-full flex items-center justify-center gap-2 text-sm">
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Sending...
          </>
        ) : (
          <>
            Send Request
            <Send className="w-4 h-4" />
          </>
        )}
      </button>
    </form>
  )
}
